import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"
import YouTubePlayer from "youtube-player"

export default class extends Controller {
  static values = {
    id: Number,
    identifier: String
  }

  static targets = ["stage"];

  initialize() {
    this.current = {};
    this.lastStopTime = 0;
    this.element['youtube'] = this;
  }

  connect() {
    const player = YouTubePlayer(this.stageTarget, {
      width: '100%',
      height: '100%',
    });

    player.on('ready', e => {
      this.youtube = e.target;
    });

    player.on('stateChange', e => {
      let time= e.target.playerInfo.currentTime;

      // PLAYING
      if ( e.data === 1 ) {
        if ( Math.abs(this.lastStopTime - time) < 0.5 ){
          time = this.lastStopTime;
        }

        this.current = { video_id: this.idValue, start_time: this.toTenth(time) };
      }

      // PAUSED
      if ( e.data === 2 ){
        this.current.end_time = this.toTenth(time);
        this.lastStopTime = time;
        this.fireEvent();
      }

      // ENDED
      if ( e.data === 0 ){
        this.current.end_time = this.toTenth(time);
        this.lastStopTime = time;
        this.fireEvent();
      }
    });

    player.loadVideoById({ 'videoId': this.identifierValue });

    // Add window unload handler to save playback event if player is playing
    this.handleWindowUnload = this.handleWindowUnload.bind(this);
    window.addEventListener('beforeunload', this.handleWindowUnload);
  }

  disconnect() {
    // Clean up window event listener
    if (this.handleWindowUnload) {
      window.removeEventListener('beforeunload', this.handleWindowUnload);
    }
  }

  get player () {
    return this.youtube;
  }

  handleWindowUnload() {
    // Check if player is currently playing and save the playback event
    if (this.youtube && this.current && this.current.start_time !== undefined) {
      const playerState = this.youtube.getPlayerState();
      // YouTube player state 1 = playing
      if (playerState === 1) {
        const currentTime = this.youtube.getCurrentTime();
        this.current.end_time = this.toTenth(currentTime);
        
        // Use sendBeacon for reliable delivery during page unload
        if (navigator.sendBeacon) {
          const formData = new FormData();
          formData.append('video_id', this.current.video_id);
          formData.append('start_time', this.current.start_time);
          formData.append('end_time', this.current.end_time);
          
          // Add CSRF token for Rails authenticity verification
          const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
          if (csrfToken) {
            formData.append('authenticity_token', csrfToken);
          }
          
          navigator.sendBeacon(document.body.dataset.playbacksUrl, formData);
        } else {
          // Fallback for browsers without sendBeacon
          this.fireEvent();
        }
      }
    }
  }

  toTenth(time) {
    return parseFloat(time.toFixed(1));
  }

  fireEvent() {
    post(document.body.dataset.playbacksUrl, {
      responseKind: 'json',
      body: this.current
    });
  }
}
